import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { Button, Col, Container, Dropdown, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { ThreeDotSpinner } from '../../common/loader/loader';
import orderService from '../../service/OrderService';
import { OrderStatus, SortBy, SortingOrder } from '../../common/constant';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { gKey } from '../../config/config';

export const OrderManagemet = () => {

  const [Loader, setLoader] = useState(false)
  const [orders, setOrders] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })
  const [status, setStatus] = useState("")
  const [sortBy, setSortBy] = useState("")
  const [sortingOrder, setSortingOrder] = useState()
  const [location, setLocation] = useState(null);
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  useEffect(() => {
    fetchOrders()
  }, [])

  const fetchOrders = async (pageNumber = pagination.pageNumber, pageSize = pagination.pageSize, status = "", sortBy = "", sortingOrder = -1, latitude = '', longitude = '') => {
    setLoader(true);
    const params = {
      page: pageNumber - 1,
      size: pageSize,
      sortingOrder: sortingOrder
    };
    if (latitude && longitude) {
      params.latitude = latitude;
      params.longitude = longitude;
    }
    if (status) {
      params.status = status;
    }

    if (sortBy) {
      params.sortBy = sortBy;
    }
    const response = await orderService.getAll(params);

    if (response.status === 200) {
      setOrders(response.data.data.orders);
      setPagination(prev => ({
        ...prev,
        pageNumber,
        pageSize,
        totalCount: response.data.data.count
      }));
    }
    setLoader(false);
  };

  const handlePageChange = (pageNumber) => {
    setPagination(prev => ({
      ...prev,
      pageNumber
    }));
    fetchOrders(pageNumber, pagination.pageSize, status, sortBy, sortingOrder, coordinates.lat, coordinates.lng);
  };

  const handleClearFilter = () => {
    setStatus('');
    setSortBy('');
    setSortingOrder('');
    setLocation('')
    window.location.reload();
  };

  const handleFilterChange = (e, type) => {
    let value = e.target.value.trim();
    if (value === '' || value === 'all') value = null;

    let updatedStatus = status;
    let updatedSortBy = sortBy;

    if (type === 'status') {
      setStatus(value);
      updatedStatus = value;
    } else if (type === 'sort') {
      setSortBy(value);
      updatedSortBy = value;
    }

    setPagination(prev => ({
      ...prev,
      pageNumber: 1
    }));

    fetchOrders(1, pagination.pageSize, updatedStatus, updatedSortBy, sortingOrder, coordinates.lat, coordinates.lng);
  };

  const handleSelect = (place) => {
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ placeId: place.value.place_id }, (results, status1) => {
      if (status1 === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        setCoordinates({ lat, lng });
        console.log('Latitude:', lat);
        console.log('Longitude:', lng);
        fetchOrders(1, pagination.pageSize, status, sortBy, sortingOrder, lat, lng);
      }
    });
  };


  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-between align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">

                  {/* Left Side - Title */}
                  <div>
                    <h2 className="m-0">Order Management</h2>
                  </div>

                  {/* Right Side - Filters + Search */}
                  <div className="d-flex flex-wrap align-items-center gap-4">

                    {/* Location Search */}
                    <div className='position-relative select-loc'>
                    <GooglePlacesAutocomplete
                        apiKey={gKey}
                        debounce={300}
                        defaultShow={false}
                        selectProps={{
                          value: location,
                          onChange: (val) => {
                            setLocation(val);
                            handleSelect(val);
                          },
                          placeholder: 'Search for a location...',
                        }}
                      />
                    </div>

                    {/* Status Filter */}
                    <div className='filter-section'>
                      <select className='form-select' onChange={(e) => handleFilterChange(e, 'status')}>
                        <option value='all'>All</option>
                        {
                          Object.entries(OrderStatus).map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                          ))
                        }
                      </select>
                    </div>

                    {/* Sort By Filter */}
                    <div className='filter-section'>
                      <select className='form-select sorting-field' defaultValue="" onChange={(e) => handleFilterChange(e, 'sort')}>
                        <option value='' disabled>Sort By</option>
                        {
                          Object.entries(SortBy).map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                          ))
                        }
                      </select>
                    </div>

                    {/* Sorting Order Filter */}
                    <div className='filter-section'>
                      <select className='form-select sorting-field' defaultValue="" onChange={(e) => {
                        const sortingOrder = parseInt(e.target.value);
                        setSortingOrder(sortingOrder);
                        if (!isNaN(sortingOrder)) {
                          fetchOrders(pagination.pageNumber, pagination.pageSize, status, sortBy, sortingOrder,coordinates.lat, coordinates.lng);
                        }
                      }}>
                        <option value='' disabled>Sorting Order</option>
                        {
                          Object.entries(SortingOrder).map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='filter-section sorting-field'>
                      <Button onClick={() => handleClearFilter()}>Clear All</Button>
                    </div>

                  </div>
                </div>
              </Col>
            </Row>


            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>
                        <th>Product</th>
                        <th>Seller</th>
                        <th>Bid duration days</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {orders.length > 0 &&
                        orders.map((order, index) => (
                          <tr key={index}>
                            <td>{moment(order.createdAt).format('DD-MM-YYYY')}</td>
                            <td>
                              <a
                                href={`/products/${order?.product?._id}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                  {order?.product?.name}
                                </div>
                              </a>
                            </td>
                            <td>
                              <a
                                href={`/users/${order?.seller?._id}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                  {order?.seller?.fullName}
                                </div>
                              </a>
                            </td>
                            <td>{order?.bidDurationDays}</td>
                            <td className="wrap-text">{order?.address}</td>
                            <td>{OrderStatus[order?.status] || order?.status}</td>
                            <td>
                              <Link to={`/order-detail/${order._id}`}>
                                <div className="view-btn-main" style={{ cursor: "pointer" }}>
                                  <i className="fa-solid fa-eye"></i>
                                </div>
                              </Link>
                            </td>

                          </tr>
                        ))
                      }

                      {
                        pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  }
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
